/**
 * Explanner Service Documentation
 * Explanner Service Documentation
 *
 * The version of the OpenAPI document: 1.7_landesstelle{20240611@153537}
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GenericFormularField } from './genericFormularField';
import { ProjectData } from './projectData';

export interface Reference {
  dataType?: Reference.DataTypeEnum;
  projectData?: ProjectData;
  fields?: Array<GenericFormularField>;
}

export namespace Reference {
  export type DataTypeEnum = 'ADDRESS' | 'INSTITUTE' | 'OBJECT';
  export const DataTypeEnum = {
    Address: 'ADDRESS' as DataTypeEnum,
    Institute: 'INSTITUTE' as DataTypeEnum,
    Object: 'OBJECT' as DataTypeEnum,
  };
}
